import { AlertCircle } from "lucide-react";

export const Req = () => <span aria-hidden="true" className="text-red-600 font-bold">*</span>;

export const RequiredLegend = ({ testId }) => (
  <p data-testid={testId} className="text-xs text-slate-500"><Req /> Champs obligatoires</p>
);

export const FieldError = ({ id, error }) =>
  error ? (
    <span data-testid={`${id}-error`} role="alert" className="flex items-center gap-1 text-xs font-medium text-red-600">
      <AlertCircle className="w-3.5 h-3.5 shrink-0" /> {error}
    </span>
  ) : null;

export const Field = ({ id, label, error, optional, required, children }) => (
  <label htmlFor={id} className="flex flex-col gap-1.5">
    <span className="text-sm font-semibold text-slate-800">
      {label} {required && <Req />} {optional && <span className="font-normal text-slate-400">(facultatif)</span>}
    </span>
    {children}
    <FieldError id={id} error={error} />
  </label>
);

export const FormSummary = ({ errors, testId }) =>
  Object.keys(errors).length ? (
    <div data-testid={testId} role="alert" className="flex items-center gap-2 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm font-medium px-4 py-3">
      <AlertCircle className="w-4 h-4 shrink-0" /> Merci de compléter les champs obligatoires signalés en rouge.
    </div>
  ) : null;

export const focusFirstError = (form) =>
  requestAnimationFrame(() => {
    const el = form?.querySelector('[aria-invalid="true"]');
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.focus({ preventScroll: true });
  });

export const POSTAL_ERROR = (cp) => {
  if (!cp) return "Le code postal est obligatoire.";
  if (!/^\d{5}$/.test(cp)) return "Code postal invalide : il doit comporter 5 chiffres.";
  if (cp.startsWith("20")) return "Désolé, nous ne livrons pas la Corse (codes postaux 20xxx). Livraison en France métropolitaine continentale uniquement.";
  if (["97", "98"].includes(cp.slice(0, 2))) return "Désolé, nous ne livrons pas les DOM-TOM (codes postaux 97xxx / 98xxx). Livraison en France métropolitaine uniquement.";
  const dep = Number(cp.slice(0, 2));
  if (dep < 1 || dep > 95) return "Code postal invalide pour la France métropolitaine.";
  return null;
};

export const PHONE_OK = (p) => /^(?:\+33\s?|0)[1-9](?:[\s.-]?\d{2}){4}$/.test(p.trim());
export const EMAIL_OK = (e) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e.trim());

export const PHONE_ERROR = (p) =>
  !p.trim() ? "Le téléphone est obligatoire." : PHONE_OK(p) ? null : "Numéro invalide : 10 chiffres (ex. 06 12 34 56 78) ou +33 6 12 34 56 78.";
export const EMAIL_ERROR = (e) => (!e.trim() ? "L'e-mail est obligatoire." : EMAIL_OK(e) ? null : "Adresse e-mail invalide (ex. nom@exemple.fr).");

export const clean = (e) => Object.fromEntries(Object.entries(e).filter(([, v]) => v));
